import { HotelPurchaseModel } from 'api-hooks/order/hotel';
import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { MainAdditionalFormType } from 'legacy-modules/order/ticket-order/components/form-type';
import * as Yup from 'yup';

export const HotelPurchaseGuestItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    isLead: Yup.bool().default(false),

    //additonal information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const HotelPurchaseHotelItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    checkIn: Yup.date().default(new Date()),
    detail: Yup.string().default(''),
    checkOut: Yup.date().default(new Date()),
    hotelRoomId: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    night: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    room: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    pax: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additonal information
    customId: Yup.string(),
    hotelRoomName: Yup.string().default(''),
  });

export const HotelPurchaseAddOnsItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    priceUnit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    unit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const HotelPurchaseItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    bookingCode: Yup.string().default(''),
    hotelId: Yup.string().default(''),
    isCityTax: Yup.bool().default(false),
    isByPax: Yup.bool().default(false),
    cityTax: Yup.string().default(''),

    hotelPurchaseGuests: Yup.array(HotelPurchaseGuestItemFormSchema()).default(
      [],
    ),
    hotelPurchaseHotels: Yup.array(HotelPurchaseHotelItemFormSchema()).default(
      [],
    ),
    hotelPurchaseAddOns: Yup.array(HotelPurchaseAddOnsItemFormSchema()).default(
      [],
    ),

    defaultCheckInOut: Yup.object({
      in: Yup.string(),
      out: Yup.string(),
    }),

    //additional information
    customId: Yup.string(),
    hotelName: Yup.string().default(''),
    remark: Yup.string().default(''),
    hotelPhone: Yup.string().default(''),
    hotelEmail: Yup.string().default(''),
    hotelAddress: Yup.string().default(''),
  });

export const HotelPurchaseFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    type: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    tourRefId: Yup.string(),
    invoiceRefId: Yup.string(),
    agentId: Yup.string().default(''),
    paymentChannelId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    commission: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    hotelPurchases: Yup.array(HotelPurchaseItemFormSchema()).default([]),
  });

export type HotelPurchaseItemFormType = Yup.InferType<
  ReturnType<typeof HotelPurchaseItemFormSchema>
>;

export type HotelPurchaseGuestItemFormType = Yup.InferType<
  ReturnType<typeof HotelPurchaseGuestItemFormSchema>
>;

export type HotelPurchaseHotelItemFormType = Yup.InferType<
  ReturnType<typeof HotelPurchaseHotelItemFormSchema>
>;

export type HotelPurchaseAddOnsItemFormType = Yup.InferType<
  ReturnType<typeof HotelPurchaseAddOnsItemFormSchema>
>;

export type HotelPurchaseFormType = Yup.InferType<
  ReturnType<typeof HotelPurchaseFormSchema>
> &
  MainAdditionalFormType & {
    hotelSale?: HotelSaleModel;
    hotelPurchase?: HotelPurchaseModel;
  };
